class NPNunnHeroSlider {
  constructor(root) {
    this.root = root;
    this.slides = [...root.querySelectorAll('[data-slide]')];
    this.dots = [...root.querySelectorAll('[data-slider-dot]')];
    this.index = 0;
    this.delay = Number(root.dataset.autoplay) || 6000;
    root.querySelector('[data-slider-prev]')?.addEventListener('click', () => this.go(this.index - 1, true));
    root.querySelector('[data-slider-next]')?.addEventListener('click', () => this.go(this.index + 1, true));
    this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.go(index, true)));
    root.addEventListener('mouseenter', () => this.stop());
    root.addEventListener('mouseleave', () => this.start());
    root.addEventListener('focusin', () => this.stop());
    root.addEventListener('focusout', () => this.start());
    let touchStart = 0;
    root.addEventListener('touchstart', event => touchStart = event.touches[0].clientX, {passive:true});
    root.addEventListener('touchend', event => {
      const distance = touchStart - event.changedTouches[0].clientX;
      if (Math.abs(distance) > 45) this.go(this.index + (distance > 0 ? 1 : -1), true);
    }, {passive:true});
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) this.start();
  }
  go(next, restart = false) {
    if (!this.slides.length) return;
    const index = (next + this.slides.length) % this.slides.length;
    this.slides.forEach((slide, i) => {
      slide.classList.toggle('is-active', i === index);
      slide.setAttribute('aria-hidden', i === index ? 'false' : 'true');
    });
    this.dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === index);
      dot.setAttribute('aria-pressed', i === index ? 'true' : 'false');
    });
    this.index = index;
    if (restart) { this.stop(); this.start(); }
  }
  start() { if (this.slides.length > 1) this.timer = window.setInterval(() => this.go(this.index + 1), this.delay); }
  stop() { window.clearInterval(this.timer); }
}
document.querySelectorAll('[data-hero-slider]').forEach(root => new NPNunnHeroSlider(root));

document.querySelectorAll('[data-shopify-inbox-trigger]').forEach(trigger => {
  trigger.addEventListener('click', event => {
    event.preventDefault();
    const fallbackUrl = trigger.getAttribute('href');
    let attempts = 0;
    const openInbox = () => {
      if (window.ShopifyChat && typeof window.ShopifyChat.open === 'function') {
        window.ShopifyChat.open();
        return true;
      }
      if (window.Shopify && window.Shopify.chat && typeof window.Shopify.chat.open === 'function') {
        window.Shopify.chat.open();
        return true;
      }
      const inboxLauncher = document.querySelector('#ShopifyChat button, [data-shopify-chat-launcher], .chat-app button');
      if (inboxLauncher) {
        inboxLauncher.click();
        return true;
      }
      return false;
    };
    if (openInbox()) return;
    const waitForInbox = window.setInterval(() => {
      attempts += 1;
      if (openInbox()) window.clearInterval(waitForInbox);
      if (attempts >= 12) {
        window.clearInterval(waitForInbox);
        if (fallbackUrl) window.location.assign(fallbackUrl);
      }
    }, 150);
  });
});

document.querySelectorAll('.product-form select[name="id"]').forEach(selector => {
  selector.addEventListener('change', event => {
    const option = event.target.selectedOptions[0];
    const productInfo = event.target.closest('[id^="ProductInfo-"]');
    const price = productInfo?.querySelector('[id^="price-"]');
    const quantity = productInfo?.querySelector('[data-quantity-variant-id]');
    if (price && option) {
      price.dataset.variantId = option.value;
      const regularPrice = price.querySelector('.price-item--regular');
      const comparePrice = price.querySelector('.price-item--sale');
      if (regularPrice) regularPrice.textContent = option.dataset.price || '';
      if (comparePrice) {
        comparePrice.textContent = option.dataset.comparePrice || '';
        comparePrice.hidden = !option.dataset.comparePrice;
      }
    }
    if (quantity && option) quantity.dataset.quantityVariantId = option.value;
    document.dispatchEvent(new CustomEvent('variant:change', { detail: { variantId: option?.value, productId: productInfo?.dataset.productId } }));
  });
});
